import {
    Component,
    Input
} from '@angular/core';
import { Tag } from 'primeng/tag';

import { UserStatus } from '@/enums';
import { ValueOrPipe } from '@/pipes';

@Component({
    selector: 'app-status',
    standalone: true,
    template: `
        <p-tag [rounded]="true" [severity]="getStatusSeverity(value)"> {{ value | valueOr }}</p-tag>`,
    imports: [
        Tag,
        ValueOrPipe
    ]
})
export class AppStatusComponent {
    @Input() value!: UserStatus | string | null;

    getStatusSeverity(status: UserStatus | string | null): string {
        switch (status) {
            case UserStatus.ACTIVE:
                return 'success';
            case UserStatus.INACTIVE:
                return 'danger';
            case UserStatus.INVITED:
                return 'warn';
            default:
                return 'primary';
        }
    }
}
